import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import * as Validator from "../../../util/validation";
import { AppState } from "../../store/app_state";

import { entity } from "src/infra/api/rpc/api";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstBreakPoint,
  ConstColor,
} from "../../../config/styles_const/styles_const";
import BtnCorporateLarge from "../atom/btn/btn_corporate_large";
import FormInput from "../atom/form/form_input";
import FormSelect from "../atom/form/form_select";
import ErrorText from "../atom/text/error_text";

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

const renderInputCustom = (field: any) => {
  const hasError = !!field.meta.error && !!field.meta.touched;

  return (
    <React.Fragment>
      <CustomInput
        {...field.input}
        type={field.type}
        placeholder={field.placeholder}
        autoComplete={`off`}
      />
      {hasError && (
        <div>
          <ErrorText>{field.meta.error}</ErrorText>
        </div>
      )}
    </React.Fragment>
  );
};

const renderSelectCustom = (field: any) => {
  const hasError = !!field.meta.error && !!field.meta.touched;

  const isPlaceholder = !field.input.value;

  return (
    <React.Fragment>
      <CustomSelect
        {...field.input}
        type={field.type}
        placeholder={field.placeholder}
        className={isPlaceholder ? "placeholder" : ""}
      >
        {field.children}
      </CustomSelect>
      {hasError && (
        <div>
          <ErrorText>{field.meta.error}</ErrorText>
        </div>
      )}
    </React.Fragment>
  );
};

interface IStateProps {
  initialValues: {
    q: string;
    category: string;
    parent: string;
    occupationSkillTag: string;
    singleSkillTag1: string;
    singleSkillTag2: string;
    singleSkillTag3: string;
    categories: entity.IOccupationSkillTagCategory[];
  };
}

interface IProps extends IStateProps {
  categories: entity.IOccupationSkillTagCategory[];
}

interface IState {}

export class ClientScoutCustomersSearchForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {};
  }

  public render(): JSX.Element {
    const { handleSubmit, form, initialValues } = this.props;

    return (
      <React.Fragment>
        <FormWrapper>
          <form name={form} onSubmit={handleSubmit}>
            <SearchInputWrapper>
              <Field
                placeholder="フリーワード検索"
                name="q"
                component={renderInputCustom}
                type="text"
                validate={[Validator.query]}
              />
              {/* <VLine>
                <Field
                  name="category"
                  component={renderSelectCustom}
                  type="text"
                  label={projectConfig.occupationLabel}
                  defaultValue={initialValues.category}
                >
                  <PlaceHolderOption value="" disabled={true}>
                    職種で絞り込む
                  </PlaceHolderOption>
                  {createSelectItem2(
                    initialValues.categories.map((item): SelectItem => {
                      return {
                        key: `${item.category}`,
                        value: item.name!,
                      };
                    }),
                    ""
                  )}
                </Field>
              </VLine> */}
              <IconButton
                name="ClientScoutCustomerListSearchForm-submit"
                aria-label="Search"
                type="submit"
                icon={"'\f002'"}
              >
                検索する
              </IconButton>
            </SearchInputWrapper>
          </form>
        </FormWrapper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  validate,
})(
  connect(mapStateToProps, mapDispatchToProps)(ClientScoutCustomersSearchForm)
);

const PlaceHolderOption = styled.option``;

const FormWrapper = styled.div`
  padding: 5px;

  background: ${ConstColor.White};

  border: none;
  box-shadow: 0px 0px 10px rgba(199, 199, 199, 0.2);
  border-radius: 10px;
  overflow: hidden;
`;

const CustomInput = styled(FormInput)`
    height: 100%;
    // border: 1px solid ${ConstColor.Base};
    border: none
    border-radius: ${ConstBorderRound.CornerRoundLeftTopLeftBottom};
    &:focus {
        border: none;
    }
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
    
    }
`;

const VLine = styled.div`
  display: none;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    border-left: 1px solid ${ConstColor.PlaceholderAndBorder};
    display: block;
  }
`;

const CustomSelect = styled(FormSelect)`
  border: none;
  display: none;
  font-size: 14px;
  &:focus {
    border: none;
  }
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    height: 100%;
    width: 190px;
    display: block;
  }
  &.placeholder {
    color: ${ConstColor.PlaceholderAndBorder};
    option {
      color: ${ConstColor.Base};
    }
  }
`;

const SearchInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const IconButton = styled(BtnCorporateLarge)`
  position: relative;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  min-height: 36px;
  margin: -6px -6px -6px 0;
  padding: 0 24px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 24px;
  background: linear-gradient(180deg, #1d1e1f 0%, #333333 100%);
  border-radius: 0;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    min-height: 47px;
    padding: 0 32px;
  }
  ::before {
    margin-right: 8px;
  }
  ::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: "";
    transition: all 0.3s ease;
    mix-blend-mode: overlay;
  }
  &:hover::after {
    background: #a5a293;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/client_scout_customes_search_form.tsx